import { render, staticRenderFns } from "./DevelopersBlock.vue?vue&type=template&id=00f5dcb6&scoped=true"
import script from "./DevelopersBlock.vue?vue&type=script&lang=js"
export * from "./DevelopersBlock.vue?vue&type=script&lang=js"
import style0 from "./DevelopersBlock.vue?vue&type=style&index=0&id=00f5dcb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00f5dcb6",
  null
  
)

export default component.exports